module.exports = __webpack_public_path__ + "static/media/ic_down_arrow.f4bbcfe1.svg";